import { AccountBillingInformation } from '@/shared/api/protocol-ts/api/billing/dto_account_pb';

import { BILLING_ZONE_WITHOUT_STRIPE_REGEXP } from '../config/constants';

export const shouldAskAdditionalInfo = (
  billingZone?: string,
  billingInformation?: AccountBillingInformation,
): boolean =>
  !BILLING_ZONE_WITHOUT_STRIPE_REGEXP.test(billingZone ?? '') &&
  (!billingInformation?.Address?.Address ||
    !billingInformation?.Phone ||
    !billingInformation?.CompanyName ||
    !billingInformation?.TaxID);
